import { render, staticRenderFns } from "./PoliceVerify.vue?vue&type=template&id=4a1de0d3&scoped=true"
import script from "./PoliceVerify.vue?vue&type=script&lang=js"
export * from "./PoliceVerify.vue?vue&type=script&lang=js"
import style0 from "./PoliceVerify.vue?vue&type=style&index=0&id=4a1de0d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1de0d3",
  null
  
)

export default component.exports